module.exports = __webpack_public_path__ + "static/media/Adobe_Photoshop_CC_icon.b5cfb3aa.svg";